module.exports = __webpack_public_path__ + "static/fancyTitleAlternative-d9568a8604892dc086a4ea1174c1959b.png";